import React from 'react';
import { MultiLinkBlock } from '@which/seatbelt';
import { pushDataLayerClick } from '../../shared/utils';
import { CommercialToolCTA } from '../CommercialToolCTA';
import styles from './OnwardJourney.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const OnwardJourney = _ref => {
  let {
    onwardJourneys,
    'aria-label': ariaLabel,
    toolName,
    itemGroup,
    ...rest
  } = _ref;
  if (!onwardJourneys || !onwardJourneys.menuData || !onwardJourneys.menuData.length) {
    return null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("nav", {
      "aria-label": ariaLabel,
      className: styles.onwardJourney,
      ...rest,
      children: onwardJourneys.menuData.map(menuDataItem => {
        const mappedLinks = mapMenuLinks(menuDataItem, toolName, itemGroup);
        return /*#__PURE__*/_jsx(MultiLinkBlock, {
          ...mappedLinks,
          className: styles.multiLinkBlock
        });
      })
    }), onwardJourneys.commercialToolCTA && onwardJourneys.commercialToolCTA.map((_ref2, index) => {
      let {
        overline_text,
        title,
        background_brand_colour,
        description,
        image,
        link_text,
        link_url,
        button_type
      } = _ref2;
      return /*#__PURE__*/_jsx(CommercialToolCTA, {
        backgroundColour: background_brand_colour?.colour,
        buttonType: button_type,
        description: description,
        image: image,
        itemGroup: itemGroup,
        linkText: link_text,
        linkUrl: link_url,
        overlineText: overline_text,
        title: title,
        toolName: toolName
      }, index);
    })]
  });
};
const mapMenuLinks = (menuDataItem, toolName, itemGroup) => ({
  headerTag: 'h2',
  title: menuDataItem.label,
  titleLink: menuDataItem.url,
  ...(menuDataItem.url && {
    titleLinkProps: {
      onClick: () => pushDataLayerClick({
        toolInfo: {
          name: toolName,
          category: itemGroup
        },
        itemText: formatItemText(menuDataItem.label)
      })
    }
  }),
  ...(menuDataItem.children && {
    links: menuDataItem.children.map(menuDataItemChild => ({
      text: menuDataItemChild.label,
      href: menuDataItemChild.url || '',
      onClick: () => pushDataLayerClick({
        toolInfo: {
          name: toolName,
          category: itemGroup
        },
        itemText: formatItemText(menuDataItemChild.label)
      })
    }))
  }),
  key: menuDataItem.url
});
const formatItemText = itemText => `${itemText.toLowerCase()} (onward journey)`;

///////// IMPLEMENTATION /////////